export default [
    '亚丁',  '华裕', '亚丁（华泰）', '亚丁（银河）'
];
